<template>
  <div>
    <div>
      <v-flex justify="center">
   <v-data-table
    :headers="headers"
    :items="Info"
    class="elevation-1"
  >
    <template v-slot:items="props">
      <td class="text-xs-right">{{ props.item.name }}</td>
      <td class="text-xs-right">{{ props.item.opinion }}</td>
    </template>
  </v-data-table>
      </v-flex>
    </div>
    
  </div>
</template>

<script>
// import { mapActions, mapGetters } from "vuex";

export default {
  components: {
  },
  props:
  {
    People: Array,
    Data: Array,
  },
  computed: {
  },
  created() {
  for (let i = 0; i < this.People.length; i++) {
    this.Info.push({name: this.People[i], opinion: this.Data[i]})
    
  }
  },
  methods: {
   
  },
  data() {
    return {
      headers:[
                      { 
          text: "Namn",
          align: "start",
          value: "name",
        },
              { 
          text: "Åsikt",
          align: "start",
          value: "opinion",
        }
        ],
      Info: [],
     
    };
  },
};
</script>

<style scoped>


</style>